import http from '@/requests/http'

class CustomTable {
  static member (params) {
    return http.post('configuration/custom-table/member/index', params)
  }
  static async memberSave (data) {
    return http.post('configuration/custom-table/member/store', data)
  }
  static consultation (params) {
    return http.post('configuration/custom-table/consultation/index', params)
  }
  static async consultationSave (data) {
    return http.post('configuration/custom-table/consultation/store', data)
  }
  static inboundDetails (params) {
    return http.post('configuration/custom-table/inbound-details/index', params)
  }
  static async inboundDetailsSave (data) {
    return http.post('configuration/custom-table/inbound-details/store', data)
  }
  static outboundDetails (params) {
    return http.post('configuration/custom-table/outbound-details/index', params)
  }
  static async outboundDetailsSave (data) {
    return http.post('configuration/custom-table/outbound-details/store', data)
  }
}

export default CustomTable
